export default "__VITE_ASSET__D_ZP2Usd__"